<script>
export default {
    name: "Image.vue",
    props: ['images', 'deal']
}
</script>

<template>

    <div class="lg:col-span-4 lg:row-end-1">
        <div class="overflow-hidden bg-gray-100 rounded-lg aspect-h-3 aspect-w-4" v-if="images.length > 0"  v-for="image in images">
            <img :src="route('deal.show.image', {deal: deal, dealImage: image})" class="object-contain"/>
        </div>
        <div v-else>
            <img src="/img/comingsoon.gif">
        </div>
    </div>

</template>

<style scoped>

</style>
